import styled from "@emotion/styled"
import { spacingStaticMd } from "@porsche-design-system/components-react/emotion"

export const FieldWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: ${spacingStaticMd} 0;
`
